module.exports = __webpack_public_path__ + "static/media/vc.4b38c063.svg";